module.exports = function getResource(label, vars = []) {
    let resources = {
        similarProductsTitle: 'Produits similaires'
    };
    return resources[label];
};
